import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const updateCacheUpdateSkills: MutationUpdaterFn<
  Schema.UpdateSkillsMutation
> = (cache, { data }) => {
  const _id = data?.updateSkills?.viewer?._id;

  const skills = data?.updateSkills?.viewer?.skills || null;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      skills: () => skills,
    },
  });
};

export const generateUpdateSkillsOptimisticResponse =
  (_id: string) =>
  ({ skillsData }: Schema.UpdateSkillsMutationVariables) => ({
    __typename: 'Mutation',
    updateSkills: {
      __typename: 'UpdateSkillsPayload',
      viewer: {
        __typename: 'Candidate',
        _id,
        skills: skillsData.skills,
      },
    },
  });
